// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".multiselect__tag-icon[data-v-ef9c3b94]:after{content:\"×\";color:#8c98a1!important;font-size:14px}.multiselect__option--highlight[data-v-ef9c3b94]{background:#dae1e7!important;outline:none;color:#606f7b!important}.multiselect__option--highlight[data-v-ef9c3b94]:after{content:attr(data-select);background:#dae1e7!important;color:#606f7b!important}", ""]);
// Exports
module.exports = exports;
